import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-analytics-trend-chart',
  templateUrl: './analytics-trend-chart.component.html',
  styleUrls: ['./analytics-trend-chart.component.scss']
})
export class AnalyticsTrendChartComponent implements OnChanges {
  @Input() data: number[] = [];
  @Input() labels: string[] = [];
  @Input() barColor: string = '#1976d2';
  @Input() width: number = 180;
  @Input() height: number = 100;
  @Input() showPoints: boolean = true;
  @Input() showArea: boolean = true;

  trendPoints: string = '';
  xPoints: { label: string, pct: number }[] = [];
  tooltipVisible: boolean = false;
  tooltipContent: string = '';
  tooltipX: number = 0;
  tooltipY: number = 0;
  hoveredCircleIndex: number = -1;

  gradientId: string;
  areaGradientId: string;

  constructor() {
    const id = Math.random().toString(36).substring(2, 11);
    this.gradientId = `trendGradient_${id}`;
    this.areaGradientId = `areaGradient_${id}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.calculateTrendPoints();
    }
  }

  calculateTrendPoints() {
    if (!this.data || !this.data.length) {
      this.trendPoints = '';
      return;
    }

    const min = Math.min(...this.data);
    const max = Math.max(...this.data);
    
    const topPadding = 16;
    const bottomPadding = 28;
    const actualHeight = this.height - topPadding - bottomPadding;
    const n = this.data.length > 1 ? this.data.length - 1 : 1;

    this.trendPoints = this.data
      .map((val, i) => {
        const x = (i * this.width) / n;
        let y: number;
        if (max === min) {
          y = this.height / 2;
        } else {
          y = topPadding + actualHeight - ((val - min) / (max - min)) * actualHeight;
        }
        return `${x},${y}`;
      })
      .join(' ');

    this.xPoints = this.data.map((_, i) => ({
      label: this.labels && this.labels[i] ? this.labels[i] : `${i + 1}`,
      pct: (i / n) * 100
    }));
  }

  showTooltip(event: MouseEvent, value: number, index: number) {
    this.tooltipContent = value.toString();
    if (this.labels && this.labels[index]) {
        this.tooltipContent = `${this.labels[index]}: ${value}`;
    }
    
    this.hoveredCircleIndex = index;
    const target = event.currentTarget as SVGCircleElement;
    const svgElement = target.ownerSVGElement;
    
    if (svgElement) {
      const svgRect = svgElement.getBoundingClientRect();
      const containerRect = svgElement.parentElement.getBoundingClientRect();
      
      const circleX = parseFloat(target.getAttribute('cx') || '0');
      const circleY = parseFloat(target.getAttribute('cy') || '0');
      
      const scaleX = svgRect.width / this.width; 
      const scaleY = svgRect.height / this.height; 
      
      // Calculate offset of SVG within its parent container
      const offsetX = svgRect.left - containerRect.left;
      const offsetY = svgRect.top - containerRect.top;
      
      this.tooltipX = circleX * scaleX + offsetX;
      this.tooltipY = circleY * scaleY + offsetY - 15; 
    }
    
    this.tooltipVisible = true;
  }

  hideTooltip() {
    this.tooltipVisible = false;
    this.hoveredCircleIndex = -1;
  }
}
